var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layer_pop_wrap"
  }, [_c('div', {
    staticClass: "layer_pop_dim",
    staticStyle: {
      "background": "rgba(0, 0, 0, 0)"
    },
    style: _vm.active ? 'display: block;' : 'display: none'
  }, [_c('div', {
    staticClass: "layer_pop sm",
    class: _vm.active ? 'active' : '',
    attrs: {
      "data-role-popup": "modal_01",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "pop_head"
  }, [_c('h2', [_vm._v("사전 등록 정보 선택")]), _c('button', {
    staticClass: "pop_close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])]), _c('div', {
    staticClass: "pop_cont"
  }, [_c('div', {
    staticClass: "form_cont"
  }, [_c('ul', {
    staticClass: "inp_column grid-cols-2"
  }, [_vm.getRegistMaterial.registFlag ? _c('li', [_c('div', {
    staticClass: "tag_button_area",
    class: _vm.checkDictionaryData.MATERIAL ? 'disabled' : 'materials'
  }, [_c('button', {
    staticClass: "tag_button",
    on: {
      "click": function ($event) {
        return _vm.open('MATERIAL');
      }
    }
  }, [_c('em', {
    staticClass: "txt"
  }, [_vm._v("재료")])])]), _c('div', {
    staticClass: "text-center label_txt"
  }, [_vm.checkDictionaryData.MATERIAL ? _c('span', [_vm._v("연결가능")]) : _c('span', [_c('em', [_vm._v("사전 수정 필요")])])])]) : _vm._e(), _vm.getRegistAnalysis.registFlag ? _c('li', [_c('div', {
    staticClass: "tag_button_area",
    class: _vm.checkDictionaryData.PURPOSE ? 'disabled' : 'analysis'
  }, [_c('button', {
    staticClass: "tag_button",
    on: {
      "click": function ($event) {
        return _vm.open('ANALYSIS');
      }
    }
  }, [_c('em', {
    staticClass: "txt"
  }, [_vm._v("분석목적")])])]), _c('div', {
    staticClass: "text-center label_txt"
  }, [_vm.checkDictionaryData.PURPOSE ? _c('span', [_vm._v("연결가능")]) : _c('span', [_c('em', [_vm._v("사전 수정 필요")])])])]) : _vm._e(), _vm.getRegistMeasurement.registTypeError || _vm.getRegistAnalysis.registTypeError ? _c('li', [_c('div', {
    staticClass: "tag_button_area disabled"
  }, [_c('button', {
    staticClass: "tag_button",
    on: {
      "click": function ($event) {
        return _vm.open('ERROR');
      }
    }
  }, [_c('em', {
    staticClass: "txt"
  }, [_vm._v("확인필요")])])]), _vm._m(0)]) : _vm._e(), _vm.getRegistMeasurement.registFlag ? _c('li', [_c('div', {
    staticClass: "tag_button_area",
    class: _vm.checkDictionaryData.PURPOSE ? 'disabled' : 'measurement'
  }, [_c('button', {
    staticClass: "tag_button",
    on: {
      "click": function ($event) {
        return _vm.open('MEASUREMENT');
      }
    }
  }, [_c('em', {
    staticClass: "txt"
  }, [_vm._v("측정목적")])])]), _c('div', {
    staticClass: "text-center label_txt"
  }, [_vm.checkDictionaryData.PURPOSE ? _c('span', [_vm._v("연결가능")]) : _c('span', [_c('em', [_vm._v("사전 수정 필요")])])])]) : _vm._e(), _vm.getRegistEquipment.registFlag ? _c('li', [_c('div', {
    staticClass: "tag_button_area",
    class: _vm.checkDictionaryData.EQUIPMENT ? 'disabled' : 'equipment'
  }, [_c('button', {
    staticClass: "tag_button",
    on: {
      "click": function ($event) {
        return _vm.open('EQUIPMENT');
      }
    }
  }, [_c('em', {
    staticClass: "txt"
  }, [_vm._v("장비")])])]), _c('div', {
    staticClass: "text-center label_txt"
  }, [_vm.checkDictionaryData.EQUIPMENT ? _c('span', [_vm._v("연결가능")]) : _c('span', [_c('em', [_vm._v("사전 수정 필요")])])])]) : _vm._e()])])])])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center label_txt"
  }, [_c('span', [_c('em', [_vm._v("목적 분류 불일치")])])]);

}]

export { render, staticRenderFns }